//
export default [
    {
        text: '#',
        value: 'id',
        width: '5%',
    },
    {
        text: 'codigo',
        value: 'code',
        width: '20%',
    },
    {
        text: 'nombre',
        value: 'bank',
    },
    {
        text: 'creación',
        value: 'created_at',
        align: 'right',
        width: '15%',
    },
]
